// Copyright (c) Mysten Labs, Inc.
// SPDX-License-Identifier: Apache-2.0

// This file is generated by genversion.mjs. Do not edit it directly.

export const PACKAGE_VERSION = '0.41.1';
export const TARGETED_RPC_VERSION = '1.9.0';
